import React from 'react';
import clsx from 'clsx';
import moment from 'moment/moment';
import {
  Card, Typography, makeStyles, Box
} from '@material-ui/core';
import IconAvatar from 'src/components/cells/IconAvatar';
import { EventDetail } from 'src/types';
import { EVENT_ATTRIBUTES_BY_EVENT_TYPE } from 'src/constants/constants';
import EngagementNameCell from '../../../components/cells/EngagementNameCell';
import ErrorBoundary from '../../../components/ErrorBoundary';
import RelativeDate from '../../../components/RelativeDate';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  card: {
    marginLeft: theme.spacing(2),
    flexGrow: 1,
    display: 'flex',
    padding: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  date: {
    marginLeft: 'auto',
    flexShrink: 0
  },
  engagementName: {
    borderRight: `2px solid ${theme.palette.divider}`,
    paddingRight: theme.spacing(1),
    marginRight: theme.spacing(1),
  }
}));

interface Props {
  event: EventDetail,
  className?: string,
  includeEngagementName?: boolean,
}

function Activity({ event, className, includeEngagementName }: Props) {
  const classes = useStyles();
  const eventAttributes = EVENT_ATTRIBUTES_BY_EVENT_TYPE[event.eventType];

  return (
    <div className={clsx(classes.root, className)}>
      <IconAvatar iconName={eventAttributes.icon} />
      <Card className={classes.card}>
        { includeEngagementName && <Box className={classes.engagementName}><EngagementNameCell engagement={event.engagement} /></Box>}
        <Typography variant="body2">
          <ErrorBoundary>
            {eventAttributes.getStatement(event)}
          </ErrorBoundary>
        </Typography>
        <Typography className={classes.date} variant="caption">
          <RelativeDate datetime={event.createdDatetime} />
        </Typography>
      </Card>
    </div>
  );
}
export default Activity;
